<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/patrolProblemReport/add?issueType=' + pointType)">新增</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">

        <el-form-item prop="title" label="问题标题">
          <el-input clearable v-model="searchForm.title" placeholder="请输入问题标题" />

        </el-form-item>
        <el-form-item prop="status" label="问题状态">
          <el-select v-model="searchForm.status" clearable filterable placeholder="请选择问题状态">
            <el-option v-for="(item, index) of statusList" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="问题标题" prop="title"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="问题内容" prop="content">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="当前处理人姓名" prop="issueUserName">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="创建人姓名" prop="createUserName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="问题状态" prop="status">
          <template v-slot="{ row }">
            <!-- 1待分配2待处理3待审批4已完成 -->

            <el-tag type="primary" v-if="row.status == '1'">待分配</el-tag>
            <el-tag type="primary" v-if="row.status == '2'">待处理</el-tag>
            <el-tag type="primary" v-if="row.status == '3'">待审批</el-tag>
            <el-tag type="success" v-if="row.status == '4'">已完成</el-tag>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="160">
          <template v-slot="{ row }">
            <el-button type="text"
              @click="$router.push('/patrolProblemReport/detail?issueId=' + row.issueId + '&issueType=' + pointType)">详情</el-button>
            <!-- <el-button type="text"
               >处理</el-button> -->
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.issueId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'patrolProblemReport',

  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        title: null,
        status: null
      },
      // 1待分配2待处理3待审批4已完成
      statusList: [
        {
          label: '待分配',
          value: '1'
        },
        {
          label: '待处理',
          value: '2'
        },
        {
          label: '待审批',
          value: '3'
        },
        {
          label: '已完成',
          value: '4'
        }
      ],
      pointList: []

    }
  },
  computed: {
    pointType() {
      return this.$route.query.pointType // 点位类型1品控2安环
    },
    userInfo() {
      return this.$store.state.user
    },
    userId() {
      return this.userInfo.userId
    },
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    }
  },
  watch: {
    '$route.query'(newV) {
      this.resetForm()
    }
  },
  created() {
    this.loadData()
  },
  methods: {

    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.patrolProblemReport.selectPaIssueReportByPage, {
        params: {
          page: this.page,
          ...this.searchForm,
          issueType: this.pointType
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        title: null,
        status: null
      }
      this.onSearch()
    },
    deleteRow(issueId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.patrolProblemReport.deletePaIssueReport, {
          issueId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}
</style>
